import { IAttachmentResponse, IIncidentEmail, IIncidentEmailResponse } from '..'
import { IApi } from '../data_sources/api/api'
import { IChecklist } from '../models/Checklist'
import { TemplateTypes } from '../models/Template'

export class MockApi implements IApi {
  authHeaders!: { [header: string]: string }
  validateAuth!: () => Promise<void>

  _mocks = {
    getAuthenticatedPhotoUrl: jest.fn((url: string) => url),
    saveAttachment: jest.fn(() => Promise.resolve({ UUID: 'test', url: '' })),
    viewAttachment: jest.fn(() => {
      return
    }),
    deleteAttachment: jest.fn(() => Promise.resolve('OK')),
    getIncidentEmail: jest.fn((incidentId: number) =>
      Promise.resolve({ incidentId } as any as IIncidentEmailResponse)
    ),
    sendIncidentEmail: jest.fn(
      (incidentId: number, incidentEmail: IIncidentEmail) =>
        Promise.resolve({ incidentId, incidentEmail })
    ),
    saveIncidentV2: jest.fn(
      (_incident: IChecklist, _builderType: TemplateTypes) =>
        Promise.resolve({ incidentId: 1 })
    )
  }

  getAuthenticatedPhotoUrl(url: string): string {
    return this._mocks.getAuthenticatedPhotoUrl(url)
  }
  async saveAttachment(): Promise<IAttachmentResponse> {
    return this._mocks.saveAttachment()
  }
  viewAttachment(): void {
    return this._mocks.viewAttachment()
  }
  async deleteAttachment(): Promise<string> {
    return this._mocks.deleteAttachment()
  }
  getIncidentEmail(incidentId: number): Promise<IIncidentEmailResponse> {
    throw this._mocks.getIncidentEmail(incidentId)
  }
  sendIncidentEmail(
    incidentId: number,
    incidentEmail: IIncidentEmail
  ): Promise<void> {
    throw this._mocks.sendIncidentEmail(incidentId, incidentEmail)
  }
  saveIncidentV2(
    incident: IChecklist,
    builderType: TemplateTypes,
    _isExistingIncident?: boolean
  ): Promise<{ incidentId: number }> {
    return this._mocks.saveIncidentV2(incident, builderType)
  }
}
